if (!customElements.get('usp-rotator')) {
  const DESKTOP_QUERY = '(min-width: 900px)';

  class UspRotator extends HTMLElement {
    #timer = null;
    #index = 0;
    #pointed = false;
    #focused = false;
    #manual = false;

    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('[data-usp-item]'));
      this.window = this.querySelector('[data-usp-window]');
      this.prev = this.querySelector('[data-usp-prev]');
      this.next = this.querySelector('[data-usp-next]');

      if (this.items.length > 0) this.#activate(0);

      if (this.items.length < 2) {
        this.prev?.remove();
        this.next?.remove();
        return;
      }

      this.autoplay = this.dataset.interval !== '0';
      this.interval = Number(this.dataset.interval) || 4500;
      this.desktop = window.matchMedia(DESKTOP_QUERY);
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.window?.setAttribute('aria-live', 'off');

      this.prev?.addEventListener('click', () => this.#step(-1));
      this.next?.addEventListener('click', () => this.#step(1));

      this.addEventListener('pointerenter', () => {
        this.#pointed = true;
        this.#sync();
      });
      this.addEventListener('pointerleave', () => {
        this.#pointed = false;
        this.#sync();
      });
      this.addEventListener('focusin', () => {
        this.#focused = true;
        this.#sync();
      });
      this.addEventListener('focusout', (event) => {
        this.#focused = this.contains(event.relatedTarget);
        this.#sync();
      });

      this.desktop.addEventListener('change', this.#sync);
      this.reduced.addEventListener('change', this.#sync);
      document.addEventListener('visibilitychange', this.#sync);

      this.#sync();
    }

    disconnectedCallback() {
      this.desktop?.removeEventListener('change', this.#sync);
      this.reduced?.removeEventListener('change', this.#sync);
      document.removeEventListener('visibilitychange', this.#sync);
      this.#stop();
    }

    #step(delta) {
      this.#manual = true;
      this.window?.setAttribute('aria-live', 'polite');
      this.#stop();
      this.#activate(this.#index + delta);
    }

    #shouldRun() {
      return (
        this.autoplay &&
        !this.desktop.matches &&
        !this.reduced.matches &&
        !this.#manual &&
        !this.#pointed &&
        !this.#focused &&
        !document.hidden
      );
    }

    #sync = () => {
      if (this.#shouldRun()) this.#start();
      else this.#stop();
    };

    #start() {
      if (this.#timer !== null) return;
      this.#timer = setInterval(() => this.#activate(this.#index + 1), this.interval);
    }

    #stop() {
      if (this.#timer === null) return;
      clearInterval(this.#timer);
      this.#timer = null;
    }

    #activate(next) {
      const count = this.items.length;
      this.#index = ((next % count) + count) % count;
      this.items.forEach((item, i) => item.toggleAttribute('data-active', i === this.#index));
    }
  }

  customElements.define('usp-rotator', UspRotator);
}
